<template>
<div class="item-wrap notice-tab-wrap pos-r">
    <scroller
        ref="infinite"
        class="scroller"
        :on-refresh="_onRefresh"
        :on-infinite="_onEndReached"
        :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''"
    >
        <div class="list-wrap user-list-wrap">
            <div class="user-list-item-wrap" v-for="(item, index) in dataSources" :key="index">
                <message-item :item="item" :sort="index + 1" />
            </div>
            <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
        </div>
    </scroller>
</div>
</template>

<script>
import messageItem from '../item/messageItem.vue';
export default {
    name: "NoticeTab",
    props: ["item", "type"],
    components: {
        messageItem
    },
    computed: {},
    data() {
        return {
            loading: true,
            dataSources: [],
            page: 1,
            limit: 10,
        };
    },
    mounted() {
        this._requestDataSources();
    },
    methods: {
        onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            console.log('url---->', url);
            window.location.href = url;
        },

        async _requestDataSources() {
            let {
                type,
                dataSources
            } = this;
            let url = this.API.message_list;
            let data = {
                type,
                page: this.page,
                limit: this.limit,
            };
            try {
                const result = await this.$post(url, data);
                let dataSourcesTemp = this.dataSources.slice();
                let dataList = [];
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    dataList = result.data.data || [];
                    if (parseInt(data.page) === 1) {
                        dataSourcesTemp = dataList
                    } else {
                        if (dataList.length !== 0) {
                            dataSourcesTemp = dataSourcesTemp.concat(dataList);
                        }
                    }
                }
                this.dataSources = dataSourcesTemp;
                this._onStopLoading(dataList.length < this.limit);
            } catch (error) {
                this._onStopLoading(true);
            }
        },

        // 下拉刷新
        _onRefresh() {
            this.page = 1;
            this._requestDataSources();
        },

        // 上拉加载
        _onEndReached() {
            if (this.loading) return;
            this.page++;
            this._requestDataSources();
        },

        // 结束加载
        _onStopLoading(status = true) {
            console.log('status---->', status);
            setTimeout(() => {
                this.loading = false;
                this.$refs && this.$refs.infinite.finishPullToRefresh();
                this.$refs && this.$refs.infinite.finishInfinite(status);
            }, 500);
        },

    }
};
</script>

<style lang="less" scoped>
.notice-tab-wrap {
    height: calc(100vh - 5rem - 4.4rem);
}
</style>
